import type { PageRoute } from '../../page-route';
import { BrigadesPage } from './page';
export const route: PageRoute = { path: '/brigades', access: 'authed', Component: BrigadesPage };
